exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".crm-ops__muted {\n  color: #6b7280;\n  font-size: 0.92em;\n}\n.crm-ops__instruction {\n  margin-top: 2px;\n  font-size: 0.92em;\n  max-width: 34em;\n  white-space: normal;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader!./~/less-loader!./src/styles/components/crmOps.less
// module id = 2867
// module chunks = 0